module.exports = __webpack_public_path__ + "img/explain_line_white.38fc1b72.svg";